import { Card } from '@ipfabric/ui-components/Card/Card';
import { SidePanel } from '@ipfabric/ui-components/SidePanel/SidePanel';
import { prop } from '@ipfabric/utils/fp/prop';
import { ApiTableEndpointDocumentation } from 'components/ApiTable/components/ApiTableEndpointDocumentation';
import { useApiTableContextSelectors } from 'components/ApiTable/model/ApiTableModel';
import { closeDescriptionModal } from 'components/ApiTable/model/commands/closeDescriptionModal';
import type { FC } from 'react';

export const ApiTableDescriptionModal: FC = () => {
  const ctxProps = useApiTableContextSelectors({
    dispatch: prop('dispatch'),
    description: prop('description'),
  });

  if (!ctxProps.description.open) {
    return null;
  }

  return (
    <SidePanel
      title='Table Description'
      closeOnBackdropClick
      onClose={() => {
        ctxProps.dispatch(closeDescriptionModal);
      }}
    >
      <Card className='flex flex-col gap p-sm'>
        <ApiTableEndpointDocumentation />
      </Card>
    </SidePanel>
  );
};
